import ToastHighLighter from '@/lib/ToastHighLighter';

export const AlertsCode = () => {
  const language = 'html';
  const codeString = `
  // Alerts
  <div class="alert alert-primary" role="alert">
    <strong>A simple primary</strong> alert—check it out!
  </div>
  <div class="alert alert-secondary" role="alert">
    A simple secondary alert—check it out!
  </div>
  <div class="alert alert-success" role="alert">
    A simple success alert—check it out!
  </div>
  <div class="alert alert-danger" role="alert">
    A simple danger alert—check it out!
  </div>
  <div class="alert alert-warning" role="alert">
    A simple warning alert—check it out!
  </div>
  <div class="alert alert-info" role="alert">
    A simple info alert—check it out!
  </div>
  <div class="alert alert-light" role="alert">
    A simple light alert—check it out!
  </div>
  <div class="alert alert-dark" role="alert">
    A simple dark alert—check it out!
  </div>

  // Alert with close button
  <div class="alert alert-warning alert-dismissible fade show" role="alert">
    <strong>Holy guacamole!</strong> You should check in on some of those fields below.
  <button
      type="button"
      class="btn-close"
      data-bs-dismiss="alert"
      aria-label="Close"
    ></button>
  </div>  
  `;

  return (
    <>
      <ToastHighLighter
        name={'alerts'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
